/* eslint-disable react/react-in-jsx-scope */
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { memo } from "react";
import { IAccordion } from "../data/types";
import { useAccordianStyle } from "../style";

const CustomAccordion = ({ children, label, currentElement, handleClick, index }: IAccordion) => {
  const classes = useAccordianStyle({ activeElement: currentElement, identifier: index });

  const handleAccordionAction = () => {
    handleClick(currentElement === index ? null : index);
  };

  return (
    <Accordion expanded={currentElement === index}>
      <AccordionSummary
        expandIcon={<ExpandMore className={classes.expandMorIcon} />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        className={classes.summary}
        onClick={handleAccordionAction}
      >
        <Typography className={classes.label}>{label}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionBody}>
        <Typography className={classes.accordionBodyContent}>{children}</Typography>
      </AccordionDetails>
    </Accordion>
  );
};

export default memo(CustomAccordion);
